// FAQSection.js
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import FAQSidebar from './FAQSidebar';
import faqData from './faqData';

const FAQSection = () => {
  const [activeCategory, setActiveCategory] = useState('company');
  const [expandedQuestionKey, setExpandedQuestionKey] = useState(null);

  const toggleQuestion = (categoryKey, index) => {
    const key = `${categoryKey}-${index}`;
    setExpandedQuestionKey(prevKey => (prevKey === key ? null : key));
  };

  const isQuestionExpanded = (categoryKey, index) => {
    const key = `${categoryKey}-${index}`;
    return expandedQuestionKey === key;
  };


  // Updated to support subheadings and faqs array
  const renderFAQCategory = (categoryKey, categoryData) => {
    return (
      <div className="mb-6">
        {categoryData.map((section, sectionIdx) => (
          <div key={sectionIdx} className="mb-8">
            <p className="text-xl font-semibold text-[#1C52A0] mb-2">{section.subheading}</p>
            {section.faqs.map((item, faqIdx) => {
              // Unique index for expansion state
              const uniqueIdx = `${sectionIdx}-${faqIdx}`;
              return (
                <div key={uniqueIdx} className="mb-3">
                  <div
                    className={`flex items-center justify-between cursor-pointer px-4 py-3 bg-[#F5F8FB] rounded-t-lg border border-gray-200 ${isQuestionExpanded(categoryKey, uniqueIdx) ? 'border-b-0 rounded-b-none' : ''}`}
                    onClick={() => toggleQuestion(categoryKey, uniqueIdx)}
                  >
                    <span className="text-base font-medium text-[#113262]">
                      {item.question}
                    </span>
                    {isQuestionExpanded(categoryKey, uniqueIdx) ? (
                      <ChevronUp className="w-5 h-5 text-[#1C52A0]" />
                    ) : (
                      <ChevronDown className="w-5 h-5 text-gray-500" />
                    )}
                  </div>
                  {isQuestionExpanded(categoryKey, uniqueIdx) && (
                    <div className="px-4 py-3 bg-white rounded-b-lg border-l border-r border-b border-gray-200">
                      <p className="text-base text-gray-700 whitespace-pre-line">{item.answer}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="flex flex-col md:flex-row">
        {/* Left Sidebar - Categories */}
        <FAQSidebar 
          faqData={faqData} 
          activeCategory={activeCategory}
          setActiveCategory={setActiveCategory}
        />

        {/* Main Content */}
        <div className="w-full md:w-3/4">
          <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
            {renderFAQCategory(activeCategory, faqData[activeCategory])}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;